import { getUuid } from "@root/utiles/common.ts";
import i18nInstance from "@root/i18n";
import { mediaSignature } from "@root/graphql/Root.gql";
import { gqlClient } from "@root/apollo/apollo-options";
import { Message } from "element-ui";

// 获取oss参数
const getOSSData = async () => {
  let res = await gqlClient.query({
    query: mediaSignature,
    variables: { tenantCode: "23r" }
  });
  const data = res.data.mediaSignature;
  return data;
};

//上传方法
export const uploadOSS = (uploadOption: any = {}) => {
  return new Promise(async (resolve, reject) => {
    let { file } = uploadOption || { file: null };
    if (!file) {
      Message.error(i18nInstance.t("Root.Upload.select_tip") as string);
      return;
    }

    let _data, _lastTimestamp, _lastLoaded;
    const type = file.type.split("/");
    const suffix = file.name.replace(/(.*\/)*([^.]+)/i, "$2");
    const filename = getUuid(32, 16) + `.${suffix}`;
    try {
      let data = await getOSSData();
      const objectKey = data.dir + filename;
      _data = {
        objectKey,
        filePath: `${data.host}/${objectKey}`,
        accessId: data.accessid,
        policy: data.policy,
        signature: data.signature,
        ...data
      };
      var formData = new FormData();
      if (uploadOption.params != null) {
        for (let key in uploadOption.params) {
          formData.append(key, uploadOption.params[key]);
        }
      }
      formData.append("Filename", file.name);
      formData.append("key", _data.objectKey || "");
      formData.append("OSSAccessKeyId", _data.accessId);
      formData.append("policy", _data.policy); //policy
      formData.append("Signature", _data.signature); //签名
      _data.callback && formData.append("callback", _data.callback);
      formData.append("file", file);
      formData.append("success_action_status", "200"); //成功后返回的操作码

      var _url = _data.host;
      var xhr = new XMLHttpRequest();
      var action = _url || uploadOption.action;
      xhr.open("POST", action);

      // ****** event Listenter ******
      //upload start
      xhr.upload.onloadstart = function (event) {
        _lastTimestamp = event.timeStamp;
        _lastLoaded = 0;
        if (uploadOption.startCallback) {
          uploadOption.startCallback(file);
        }
      };
      //upload progress
      xhr.upload.onprogress = function (event) {
        var offtimestamp = event.timeStamp - _lastTimestamp;
        _lastTimestamp = event.timeStamp;
        var offloaded = event.loaded - _lastLoaded;
        _lastLoaded = event.loaded;
        offtimestamp = offtimestamp / 1000; //转换成秒
        offloaded = offloaded / 1024; //转换成KB
        var speed = Math.round(offloaded / offtimestamp); // KB/S
        var progress = event.loaded / event.total; // 0~1
        var total = Math.round(event.total / 1024); // KB
        if (uploadOption.progressCallback) {
          uploadOption.progressCallback({
            computable: event.lengthComputable,
            speed: speed,
            progress: progress,
            total: total,
            event: event
          });
        }
      };
      //upload done
      xhr.onload = function (event) {
        if (uploadOption.successCallback) {
          var resultObj;
          try {
            resultObj = JSON.parse(xhr.responseText);
          } catch (error) {
            resultObj = xhr.responseText;
          }
          uploadOption.successCallback(resultObj);
          file = null;
        }
      };
      //upload error
      xhr.onerror = function (event) {
        if (uploadOption.errorCallback) {
          uploadOption.errorCallback();
        }
      };
      //upload status change
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            try {
              var resultObj = {
                data: JSON.parse(xhr.responseText || null),
                ..._data
              };
              resolve(resultObj);
            } catch (error) {
              resolve(xhr.responseText || null);
            }
          }
        }
      };
      xhr.send(formData);
    } catch (error) {
      console.log("ajax error");
      reject(error);
    }
  });
};
